import { getApiHistory } from './apiHistoryTracker';
var formatTime = function (isoString) {
    var d = new Date(isoString);
    return d.toLocaleTimeString('cs-CZ', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
};
var collectDebugInfo = function (stripes) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var lines = [];
    var now = new Date();
    lines.push('=== Debug Info ===');
    lines.push("Timestamp: ".concat(now.toLocaleString('cs-CZ'), " (").concat(Intl.DateTimeFormat().resolvedOptions().timeZone, ")"));
    lines.push("Environment: ".concat(window.location.hostname));
    lines.push("Okapi URL: ".concat((_b = (_a = stripes.okapi) === null || _a === void 0 ? void 0 : _a.url) !== null && _b !== void 0 ? _b : 'N/A'));
    lines.push("Tenant: ".concat((_d = (_c = stripes.okapi) === null || _c === void 0 ? void 0 : _c.tenant) !== null && _d !== void 0 ? _d : 'N/A'));
    lines.push("Current Route: ".concat(window.location.pathname).concat(window.location.search));
    lines.push("User Agent: ".concat(navigator.userAgent));
    lines.push("Screen: ".concat(window.screen.width, "x").concat(window.screen.height));
    lines.push("Window: ".concat(window.innerWidth, "x").concat(window.innerHeight));
    lines.push('');
    lines.push('=== User ===');
    var user = (_e = stripes.user) === null || _e === void 0 ? void 0 : _e.user;
    if (user) {
        lines.push("Username: ".concat((_f = user.username) !== null && _f !== void 0 ? _f : 'N/A'));
        lines.push("User ID: ".concat((_g = user.id) !== null && _g !== void 0 ? _g : 'N/A'));
        lines.push("Name: ".concat((_h = user.firstName) !== null && _h !== void 0 ? _h : '', " ").concat((_j = user.lastName) !== null && _j !== void 0 ? _j : '').trim());
    }
    else {
        lines.push('User: not loaded');
    }
    var rolesRaw = sessionStorage.getItem('activeRoles');
    var roles = [];
    try {
        if (rolesRaw && rolesRaw !== 'undefined') {
            roles = JSON.parse(rolesRaw);
        }
    }
    catch (_r) { }
    lines.push("Roles: ".concat(roles.length > 0 ? roles.join(', ') : 'N/A'));
    var perms = (_k = stripes.user) === null || _k === void 0 ? void 0 : _k.perms;
    if (perms) {
        var permNames = Object.keys(perms).filter(function (k) { return perms[k]; });
        lines.push("Permissions (".concat(permNames.length, "): ").concat(permNames.join(', ') || 'none'));
    }
    else {
        lines.push('Permissions: not loaded');
    }
    lines.push('');
    lines.push('=== App State ===');
    lines.push("Authenticated: ".concat((_m = (_l = stripes.okapi) === null || _l === void 0 ? void 0 : _l.isAuthenticated) !== null && _m !== void 0 ? _m : 'N/A'));
    lines.push("Locale: ".concat((_o = stripes.locale) !== null && _o !== void 0 ? _o : 'N/A'));
    lines.push("App Timezone: ".concat((_p = stripes.timezone) !== null && _p !== void 0 ? _p : 'N/A'));
    lines.push("Browser Timezone: ".concat(Intl.DateTimeFormat().resolvedOptions().timeZone));
    var modules = (_q = stripes.discovery) === null || _q === void 0 ? void 0 : _q.modules;
    if (modules) {
        var moduleNames = Object.values(modules);
        lines.push("Loaded modules (".concat(moduleNames.length, "): ").concat(moduleNames.join(', ')));
    }
    lines.push('');
    var apiHistory = getApiHistory();
    lines.push("=== Recent API Calls (".concat(apiHistory.length, ") ==="));
    if (apiHistory.length === 0) {
        lines.push('No API calls recorded yet.');
    }
    else {
        for (var _i = 0, apiHistory_1 = apiHistory; _i < apiHistory_1.length; _i++) {
            var entry = apiHistory_1[_i];
            var time = formatTime(entry.timestamp);
            var statusStr = entry.error
                ? "ERR: ".concat(entry.error)
                : String(entry.status);
            lines.push("[".concat(time, "] ").concat(entry.method, " ").concat(entry.url, " \u2192 ").concat(statusStr, " (").concat(entry.durationMs, "ms)"));
            if (entry.requestBody) {
                lines.push("  \u2190 Request: ".concat(entry.requestBody));
            }
            if (entry.responseBody) {
                lines.push("  \u2192 Response: ".concat(entry.responseBody));
            }
        }
    }
    return lines.join('\n');
};
export { collectDebugInfo };
